import { render, staticRenderFns } from "./KnowledgeForm.vue?vue&type=template&id=16d7e08e&scoped=true"
import script from "./KnowledgeForm.vue?vue&type=script&lang=js"
export * from "./KnowledgeForm.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeForm.vue?vue&type=style&index=0&id=16d7e08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d7e08e",
  null
  
)

export default component.exports